<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>atrás</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">Departamento :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changedValue"
                                    :options="departmentArr" :clearable=false placeholder="Seleccionar departamento">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Empolyee Number -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">Numero de Empleado :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeNumberError = ''" maxlength="190" class="form-control" v-model="employeeNumber" id="empolyee_name" placeholder="Ingrese el Numero de Empleado" name="employeeNumber">
                                <div class="help is-danger">{{employeeNumberError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Empolyee Name -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">Nombre Completeo :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeNameError = ''" maxlength="190" class="form-control" v-model="employeeName" id="empolyee_name" placeholder="Ingrese el Nombre Completeo" name="employeeName">
                                <div class="help is-danger">{{employeeNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Date -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">Fecha :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker @input="dateError = ''" placeholder="MM/DD/YYYY" id="date_of_request" name="date" v-model="date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                <div class="help is-danger">{{dateError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Location -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">Localidad :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="location" name="location"
                                    label="name" placeholder="Seleccionar Localidad"
                                    @input="location_error = ''"
                                    :options="location_arr" :clearable=false>
                                </v-select>
                                <div class="help is-danger">{{location_error}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Empolyee Email -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">Correo Electronico :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeEmailError = ''" maxlength="190" class="form-control" v-model="employeeEmail" id="employeeEmail" placeholder="Ingrese el Correo Electronico" name="employeeEmail">
                                <div class="help is-danger">{{employeeEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label block-title-tech-time">Correccion del Tiempo de Atendencia</div>
                            </div>
                        </div>
                        <template v-for="(attendance, index) in attendanceClockTimeArr">
                            <div :key="'date ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Fecha :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="attendance.dateError = ''" placeholder="MM/DD/YYYY" id="date" name="date" v-model="attendance.date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{attendance.dateError}}</div>
                                    <!-- <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <div :key="'Reson ' + index" class="col-5 forms-block">
                                <div class="">
                                    <div class="form-label">Razon para la editaccion :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="attendance.reasonError = ''" maxlength="190" class="form-control" v-model="attendance.reason" id="reason" name="reason">
                                    <div class="help is-danger">{{attendance.reasonError}}</div>
                                    <!-- <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <div :key="'Time In ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Tiempo de Inicio :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="attendance.timeInError = ''" placeholder="H:     M:" id="timeIn" name="timeIn" v-model="attendance.timeIn" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{attendance.timeInError}}</div>
                                    <!-- <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <div :key="'Time Out ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Tiempo Final :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="attendance.timeOutError = ''" placeholder="H:     M:" id="timeOut" name="timeOut" v-model="attendance.timeOut" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{attendance.timeOutError}}</div>
                                    <!-- <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <template v-if="attendanceClockTimeArr.length == (index + 1) && plusCountAttendance != 0">
                                <div :key="'plus ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="addNewDocumentAttendance(attendance, index)" class="btn btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div :key="'close ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="removeAttendanceDocument(attendance, index)" class="btn btn-danger">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </template>
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label block-title-tech-time">Correccion de Tiempo de Taller</div>
                            </div>
                        </div>
                        <template v-for="(shopObj, index) in shopTimeObjects">
                            <div :key="'Shop Date ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Fecha :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="shopObj.dateError = ''" placeholder="MM/DD/YYYY" id="date" name="date" v-model="shopObj.date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{shopObj.dateError}}</div>
                                </div>
                            </div>
                            <div :key="'Shop Customer Name ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Nombre del Cliente :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="shopObj.customerNameError = ''" maxlength="190" class="form-control" v-model="shopObj.customerName" placeholder="" id="customerName" name="customerName">
                                    <div class="help is-danger">{{shopObj.customerNameError}}</div>
                                </div>
                            </div>
                            <div :key="'Shop RO Number ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Numero de RO :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="shopObj.roNumberError = ''" maxlength="190" class="form-control" v-model="shopObj.roNumber" placeholder="" id="roNumber" name="roNumber">
                                    <div class="help is-danger">{{shopObj.roNumberError}}</div>
                                </div>
                            </div>
                            <div :key="'Shop Reason ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Razon para la editaccion :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="shopObj.reasonError = ''" maxlength="190" class="form-control" v-model="shopObj.reason" placeholder="" id="reason" name="reason">
                                    <div class="help is-danger">{{shopObj.reasonError}}</div>
                                </div>
                            </div>
                            <div :key="'Shop Job ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Numero de Operaccion :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="shopObj.jobError = ''" maxlength="190" class="form-control" v-model="shopObj.job" placeholder="" id="job" name="job">
                                    <div class="help is-danger">{{shopObj.jobError}}</div>
                                </div>
                            </div>
                            <div :key="'Shop Time In ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Tiempo de Inicio :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="shopObj.timeInError = ''" placeholder="H:     M:" id="timeIn" name="timeIn" v-model="shopObj.timeIn" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{shopObj.timeInError}}</div>
                                </div>
                            </div>
                            <div :key="'Shop Time Out ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Tiempo Final :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker @input="shopObj.timeOutError = ''" placeholder="H:     M:" id="timeOut" name="timeOut" v-model="shopObj.timeOut" :config="optionsTime" aria-describedby="basic-addon1"></date-picker>
                                    <div class="help is-danger">{{shopObj.timeOutError}}</div>
                                </div>
                            </div>
                            <template v-if="shopTimeObjects.length == index + 1 && plusCount != 0">
                                <div :key="'Shop Plus Button ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="addNewShopDocument(shopObj, index)" class="btn btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div :key="'Shop Close Button ' + index" class="col-1 forms-block">
                                    <button type="button" style="margin-top: 28px;" v-on:click="removeShopDocument(shopObj, index)" class="btn btn-danger">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <div :key="'Shop clearfix ' + index" class="col-0 forms-block">
                            </div>
                        </template>

                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancelar</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUpdateTechTime('save')"><span id="createAttachment">Salvar</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateSpanishTechTime',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Agregar solicitud de edición de tiempo técnico',
                edit_id: 0,
                departmentArr: [ 
                    {
                        text: 'Service',
                        value: 'Service',
                    },
                    {
                        text: 'Body Shop',
                        value: 'Body Shop',
                    },
                ],
                departmentId: "",
                departmentIdError: "",
                employeeNumber: "",
                employeeNumberError: "",
                employeeName: "",
                employeeNameError: "",
                date: new Date(),
                dateError: "",
                options: {
                    format: 'MM/DD/YYYY',
                },
                optionsTime: {
                    format: 'hh:mm A',
                },
                location: "",
                location_arr: [],
                location_error: "",
                employeeEmail: "",
                employeeEmailError: "",
                attendanceClockTimeArr: [
                    {
                        date: "",
                        dateError: "",
                        reason: "",
                        reasonError: "",
                        timeIn: "",
                        timeInError: "",
                        timeOut: "",
                        timeOutError: "",
                    },
                ],
                managerEmail: "",
                loginUserRoleId: 1,
                shopTimeObjects: [
                    {
                        date: '',
                        dateError: "",
                        customerName: '',
                        customerNameError: '',
                        roNumber: '',
                        roNumberError: '',
                        reason: '',
                        reasonError: "",
                        job: '',
                        jobError: '',
                        timeIn: '',
                        timeInError: "",
                        timeOut: '',
                        timeOutError: "",
                    },
                ],
                tempObject: {
                    date: '',
                    dateError: "",
                    customerName: '',
                    customerNameError: '',
                    roNumber: '',
                    roNumberError: '',
                    reason: '',
                    reasonError: "",
                    job: '',
                    jobError: '',
                    timeIn: '',
                    timeInError: "",
                    timeOut: '',
                    timeOutError: "",
                },
                tempObjectAttendance: {
                    date: "",
                    dateError: "",
                    reason: "",
                    reasonError: "",
                    timeIn: "",
                    timeInError: "",
                    timeOut: "",
                    timeOutError: "",
                },
                plusCount: 9,
                plusCountAttendance: 9,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("TechTimeSpanishForm");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            self.loadLocation();
            self.loadBodyShopLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/techtime/spanish/list');
            },
            changedValue: function (department) {
                self.departmentIdError = "";
                self.location_arr = [];
                self.location = "";
                if (department != 'undefined' && department.value) {
                    self.location_arr = self.serviceLocationArr;
                    if(department.value == 'Body Shop') {
                        self.location_arr = self.bodyShopLocationArr;
                    }
                }
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            /* for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                                var objLocation = self.bodyShopLocationArr[index];
                                if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                                    self.bodyShopLocationArr.splice(index, 1);
                                }
                            } */
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        // console.log(JSON.stringify(self.bodyShopLocationArr));
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 2
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            // self.location_arr = response.data.locations;
                            self.serviceLocationArr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            removeAttendanceDocument: function(object, index) {
                if(self.plusCountAttendance <= 9 ) {
                    self.plusCountAttendance = self.plusCountAttendance + 1;
                    self.attendanceClockTimeArr.splice(index, 1);
                }
            },
            addNewDocumentAttendance: function (object, index) {
                var error = true;
                var todayDate = moment().format("MM/DD/YYYY");
                self.attendanceClockTimeArr[index].dateError = "";
                self.attendanceClockTimeArr[index].reasonError = "";
                self.attendanceClockTimeArr[index].timeInError = "";
                self.attendanceClockTimeArr[index].timeOutError = "";

                if(!self.attendanceClockTimeArr[index].date) {
                    self.attendanceClockTimeArr[index].dateError = "Seleccione fecha";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].reason) {
                    self.attendanceClockTimeArr[index].reasonError = "Ingrese la razón";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].timeIn) {
                    self.attendanceClockTimeArr[index].timeInError = "Seleccionar tiempo en";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.attendanceClockTimeArr[index].timeOut) {
                    self.attendanceClockTimeArr[index].timeOutError = "Seleccionar tiempo de espera";
                    if (error) {
                        error = false;
                    }
                }
                if(self.attendanceClockTimeArr[index].timeIn != '' && self.attendanceClockTimeArr[index].timeOut != '') {
                    var stratDateTime = todayDate + ' ' + self.attendanceClockTimeArr[index].timeIn + ':00';
                    var endDateTime = todayDate + ' ' + self.attendanceClockTimeArr[index].timeOut + ':00';
                    if(stratDateTime == endDateTime) {
                        self.attendanceClockTimeArr[index].timeOutError = "Seleccionar tiempo de espera válido";
                        if (error) {
                            error = false;
                        }
                    } else {
                        stratDateTime = new Date(stratDateTime);
                        endDateTime = new Date(endDateTime);
                        if(endDateTime < stratDateTime) {
                            self.attendanceClockTimeArr[index].timeOutError = "Seleccionar tiempo de espera válido";
                            if (error) {
                                error = false;
                            }
                        }
                    }
                }
                if(error) {
                    self.plusCountAttendance = self.plusCountAttendance - 1;
                    self.attendanceClockTimeArr.push(Vue.util.extend({}, self.tempObjectAttendance));
                }
            },
            removeShopDocument: function(object, index) {
                if(self.plusCount <= 9 ) {
                    self.plusCount = self.plusCount + 1;
                    self.shopTimeObjects.splice(index, 1);
                }
            },
            addNewShopDocument: function (object, index) {
                var error = true;
                var todayDate = moment().format("MM/DD/YYYY");
                var tempShopObj = self.shopTimeObjects[index];
                tempShopObj.dateError = "";
                tempShopObj.customerNameError = "";
                tempShopObj.roNumberError = "";
                tempShopObj.reasonError = "";
                tempShopObj.jobError = "";
                tempShopObj.timeInError = "";
                tempShopObj.timeOutError = "";

                if(!tempShopObj.date) {
                    tempShopObj.dateError = "Seleccione fecha";
                    if (error) {
                        error = false;
                    }
                }
                if(!tempShopObj.customerName) {
                    tempShopObj.customerNameError = "Ingrese el nombre del cliente";
                    if (error) {
                        error = false;
                    }
                }
                if(!tempShopObj.roNumber) {
                    tempShopObj.roNumberError = "Ingrese el número de RO";
                    if (error) {
                        error = false;
                    }
                }
                if(!tempShopObj.reason) {
                    tempShopObj.reasonError = "Ingrese la razón";
                    if (error) {
                        error = false;
                    }
                }
                if(!tempShopObj.job) {
                    tempShopObj.jobError = "Ingresar trabajo";
                    if (error) {
                        error = false;
                    }
                }
                if(!tempShopObj.timeIn) {
                    tempShopObj.timeInError = "Seleccionar tiempo en";
                    if (error) {
                        error = false;
                    }
                }
                if(!tempShopObj.timeOut) {
                    tempShopObj.timeOutError = "Seleccionar tiempo de espera";
                    if (error) {
                        error = false;
                    }
                }
                if(tempShopObj.timeIn != '' && tempShopObj.timeOut != '') {
                    var stratDateTime = todayDate + ' ' + tempShopObj.timeIn + ':00';
                    var endDateTime = todayDate + ' ' + tempShopObj.timeOut + ':00';
                    if(stratDateTime == endDateTime) {
                        tempShopObj.timeOutError = "Seleccionar tiempo de espera válido";
                        if (error) {
                            error = false;
                        }
                    } else {
                        stratDateTime = new Date(stratDateTime);
                        endDateTime = new Date(endDateTime);
                        if(endDateTime < stratDateTime) {
                            tempShopObj.timeOutError = "Seleccionar tiempo de espera válido";
                            if (error) {
                                error = false;
                            }
                        }
                    }
                }
                if(error) {
                    self.plusCount = self.plusCount - 1;
                    self.shopTimeObjects.push(Vue.util.extend({}, self.tempObject))
                }
            },
            checkForm: function () {
                var checked = true;
                var isEnterAttendanceMapperData = false;
                var isEnterShopMapperData = false;
                var todayDate = moment().format("MM/DD/YYYY");
                self.employeeNumberError = "";
                self.employeeNameError = "";
                self.dateError = "";
                self.employeeEmailError = "";
                self.location_error = "";
                self.departmentIdError = "";

                if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "Seleccionar departamento";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeNumber) {
                    self.employeeNumberError = "Ingrese el Numero de Empleado";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeName) {
                    self.employeeNameError = "Ingrese el Nombre Completeo";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date) {
                    self.dateError = "Seleccione fecha";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.location_error = "Seleccionar Localidad";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeEmail) {
                    self.employeeEmailError = "Ingrese el Correo Electronico:";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.employeeEmail && !self.validEmail(self.employeeEmail)) {
                    self.employeeEmailError = "Ingrese un Correo Electronico válido del empleado";
                    if (checked) {
                        checked = false;
                    }
                }

                if(self.attendanceClockTimeArr && self.attendanceClockTimeArr.length > 0) {
                    for(var index = 0; index < self.attendanceClockTimeArr.length; index++) {
                        var obj = self.attendanceClockTimeArr[index];
                        obj.dateError = "";
                        obj.reasonError = "";
                        obj.timeInError = "";
                        obj.timeOutError = "";
                        if(obj.date != '' || obj.reason != '' || obj.timeIn != '' || obj.timeOut != '') {
                            isEnterAttendanceMapperData = true;
                            if(!obj.date) {
                                obj.dateError = "Seleccione fecha";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!obj.reason) {
                                obj.reasonError = "Ingrese la razón";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!obj.timeIn) {
                                obj.timeInError = "Seleccionar Tiempo de Inicio";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!obj.timeOut) {
                                obj.timeOutError = "Seleccionar Tiempo Final";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(obj.timeIn != '' && obj.timeOut != '') {
                                var stratDateTime = todayDate + ' ' + obj.timeIn + ':00';
                                var endDateTime = todayDate + ' ' + obj.timeOut + ':00';
                                if(stratDateTime == endDateTime) {
                                    obj.timeOutError = "Seleccionar Tiempo Final válido";
                                    if (checked) {
                                        checked = false;
                                    }
                                } else {
                                    stratDateTime = new Date(stratDateTime);
                                    endDateTime = new Date(endDateTime);
                                    if(endDateTime < stratDateTime) {
                                        obj.timeOutError = "Seleccionar Tiempo Final válido";
                                        if (checked) {
                                            checked = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if(self.shopTimeObjects && self.shopTimeObjects.length > 0) {
                    for(var index = 0; index < self.shopTimeObjects.length; index++) {
                        var tempShopObj = self.shopTimeObjects[index];
                        tempShopObj.dateError = "";
                        tempShopObj.customerNameError = "";
                        tempShopObj.roNumberError = "";
                        tempShopObj.reasonError = "";
                        tempShopObj.jobError = "";
                        tempShopObj.timeInError = "";
                        tempShopObj.timeOutError = "";
                        if(tempShopObj.date != '' || tempShopObj.customerName != '' || tempShopObj.roNumber != '' || tempShopObj.reason != '' || tempShopObj.job != '' || tempShopObj.timeIn || tempShopObj.timeOut) {
                            isEnterShopMapperData = true;
                            if(!tempShopObj.date) {
                                tempShopObj.dateError = "Seleccione fecha";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!tempShopObj.customerName) {
                                tempShopObj.customerNameError = "Ingrese el Nombre del Cliente";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!tempShopObj.roNumber) {
                                tempShopObj.roNumberError = "Ingrese el Numero de RO";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!tempShopObj.reason) {
                                tempShopObj.reasonError = "Ingrese la razón";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!tempShopObj.job) {
                                tempShopObj.jobError = "Ingresar Numero de Operaccion";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!tempShopObj.timeIn) {
                                tempShopObj.timeInError = "Seleccionar Tiempo de Inicio";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(!tempShopObj.timeOut) {
                                tempShopObj.timeOutError = "Seleccionar Tiempo Final";
                                if (checked) {
                                    checked = false;
                                }
                            }
                            if(tempShopObj.timeIn != '' && tempShopObj.timeOut != '') {
                                var stratDateTime = todayDate + ' ' + tempShopObj.timeIn + ':00';
                                var endDateTime = todayDate + ' ' + tempShopObj.timeOut + ':00';
                                if(stratDateTime == endDateTime) {
                                    tempShopObj.timeOutError = "Seleccionar Tiempo Final válido";
                                    if (checked) {
                                        checked = false;
                                    }
                                } else {
                                    stratDateTime = new Date(stratDateTime);
                                    endDateTime = new Date(endDateTime);
                                    if(endDateTime < stratDateTime) {
                                        tempShopObj.timeOutError = "Seleccionar Tiempo Final válido";
                                        if (checked) {
                                            checked = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if(!isEnterShopMapperData && !isEnterAttendanceMapperData) {
                    self.showSAlert('Ingrese al menos datos de correcciones de tiempo de reloj de asistencia o de tiempo de tienda', 'info');
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addUpdateTechTime(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            manager_email: self.managerEmail,
                            empolyee_number: self.employeeNumber,
                            date: self.date,
                            empolyee_name: self.employeeName,
                            location_id: self.location.id,
                            location: self.location.name,
                            employee_email: self.employeeEmail,
                            attendanceClockTimeArr: self.attendanceClockTimeArr,
                            shopTimeObjects: self.shopTimeObjects,
                            departmentName: self.departmentId.value,
                            is_spanish: 1
                        };
                        self.showLoader();
                        HTTP.post("/techtime/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.departmentId = '';
                                        self.employeeNumber = '';
                                        self.date = '';
                                        self.employeeName = '';
                                        self.location = '';
                                        self.employeeEmail = '';
                                        self.managerEmail = '';
                                        self.attendanceClockTimeArr = [];
                                        self.attendanceClockTimeArr = [
                                            {
                                                date: "",
                                                dateError: "",
                                                reason: "",
                                                reasonError: "",
                                                timeIn: "",
                                                timeInError: "",
                                                timeOut: "",
                                                timeOutError: "",
                                            },
                                        ];
                                        self.plusCountAttendance = 9;
                                        self.shopTimeObjects = [];
                                        self.shopTimeObjects = [
                                            {
                                                date: '',
                                                dateError: "",
                                                customerName: '',
                                                customerNameError: '',
                                                roNumber: '',
                                                roNumberError: '',
                                                reason: '',
                                                reasonError: "",
                                                job: '',
                                                jobError: '',
                                                timeIn: '',
                                                timeInError: "",
                                                timeOut: '',
                                                timeOutError: "",
                                            }
                                        ];
                                        self.plusCount = 9;
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>
<style scoped>
    .block-title-tech-time {
        float: left;
        width: 100%;
        margin: 0 0 15px 0;
        padding: 0;
        font-weight: normal;
        font-size: 28px;
        color: #0f467c;
        font-family: 'SanFranciscoDisplay-Bold';
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/TechTimeMaster/AddUpdateSpanishTechTime.vue